// Vue Router
import VueRouter from 'vue-router'
import AuthService from '@/services/auth.service'
import Cookies from 'js-cookie'

// Layout
const DefaultLayout = () => import('@/layouts/Default')

// Pages
const Index = () => import('@/pages/Index')
const Login = () => import('@/pages/login/Index')
const ChangePassword = () => import('@/pages/change-password/Index')
const About = () => import('@/pages/about/Index')
const Styleguide = () => import('@/pages/styleguide/Index')

// Error Pages
const Page404 = () => import('@/pages/404')
const Page500 = () => import('@/pages/500')

// Users Pages
const Users = () => import('@/pages/users/Index')
const User = () => import('@/pages/users/User')

// Customers Pages
const Customers = () => import('@/pages/customers/Index')
const Customer = () => import('@/pages/customers/Customer')
const CustomersOrder = () => import('@/pages/customers/Order')

// Projects Pages
const Projects = () => import('@/pages/projects/Index')
const Project = () => import('@/pages/projects/Project')
const ProjectsOrder = () => import('@/pages/projects/Order')

// Categories Pages
const Categories = () => import('@/pages/categories/Index')
const Category = () => import('@/pages/categories/Category')

// Jobs Pages
const Jobs = () => import('@/pages/jobs/Index')
const Job = () => import('@/pages/jobs/Job')

// SEO
const SEO = () => import('@/pages/seo/Index')

// Contacts
const Contacts = () => import('@/pages/contacts/Index')

// Job Aplications
const JobAplications = () => import('@/pages/job-aplication/Index')
const JobAplication = () => import('@/pages/job-aplication/JobAplication')

// Settings
const Settings = () => import('@/pages/settings/Index')

// Router
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/change-password/:token',
      name: 'Alterar senha',
      component: ChangePassword
    },
    {
      path: '/change-password/expired/:token',
      name: 'Alterar senha expirada',
      component: ChangePassword
    },
    {
      path: '/',
      name: 'Home',
      redirect: '/dashboard',
      component: DefaultLayout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Index
        },
        {
          path: 'styleguide',
          name: 'Styleguide',
          component: Styleguide
        },
        {
          path: 'seo',
          name: 'SEO',
          component: SEO
        },
        {
          path: 'settings',
          name: 'Configurações',
          component: Settings
        },
        {
          path: 'contacts',
          name: 'Contacts',
          redirect: 'contacts/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Contacts
            },
            {
              path: ':id',
              name: 'Detalhes da mensagem',
              component: Contacts
            }
          ]
        },
        {
          path: 'users',
          name: 'Usuários',
          redirect: 'users/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Users
            },
            {
              path: 'create',
              name: 'Novo Usuário',
              component: User
            },
            {
              path: 'edit/:id',
              name: 'Editar Usuario',
              component: User
            }
          ]
        },
        {
          path: 'customers',
          name: 'Clientes',
          redirect: 'customers/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Customers
            },
            {
              path: 'create',
              name: 'Novo Cliente',
              component: Customer
            },
            {
              path: 'edit/:id',
              name: 'Editar Cliente',
              component: Customer
            },
            {
              path: 'order',
              name: 'Ordenar Clientes',
              component: CustomersOrder
            }
          ]
        },
        {
          path: 'projects',
          name: 'Projetos',
          redirect: 'projects/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Projects
            },
            {
              path: 'create',
              name: 'Novo Projeto',
              component: Project
            },
            {
              path: 'edit/:id',
              name: 'Editar Projeto',
              component: Project
            },
            {
              path: 'order',
              name: 'Ordenar Projetos',
              component: ProjectsOrder
            }
          ]
        },
        {
          path: 'categories',
          name: 'Categorias',
          redirect: 'categories/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Categories
            },
            {
              path: 'create',
              name: 'Nova Categoria',
              component: Category
            },
            {
              path: 'edit/:id',
              name: 'Editar Categoria',
              component: Category
            }
          ]
        },
        {
          path: 'jobs',
          name: 'Vagas',
          redirect: 'jobs/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Jobs
            },
            {
              path: 'create',
              name: 'Nova Vaga',
              component: Job
            },
            {
              path: 'edit/:id',
              name: 'Editar Vaga',
              component: Job
            }
          ]
        },
        {
          path: 'jobaplications',
          name: 'Currículos',
          redirect: 'jobaplications/',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: JobAplications
            },
            {
              path: 'edit/:id',
              name: 'Visualizar Currículo',
              component: JobAplication
            }
          ]
        },
        {
          path: 'about',
          name: 'Sobre',
          component: About
        }
      ]
    },
    {
      path: '/500',
      name: '500',
      component: Page500
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
})

/**
 // Authentication Logic //
*/
router.beforeEach(async (to, from, next) => {
  const publicPages = ['/login']
  const RH_EMAIL = 'rh@owinteractive.com'

  if (to.path.includes('/change-password')) {
    publicPages.push(to.path)
  }

  const authRequired = !publicPages.includes(to.path)
  const loggedIn = Cookies.getJSON('ow:user')
  const userId = Cookies.get('ow:userId')

  if (loggedIn) {
    const user = loggedIn.data.user

    // 1. Validação de Role
    if (user.roles[0].id !== 1) {
      Cookies.remove('ow:user')
      Cookies.remove('ow:userId')
      Cookies.remove('ow:link')
      return next('/login')
    }

    // 2. Trava de Segurança para o RH
    if (user.email === RH_EMAIL) {
      const allowedPaths = [
        '/dashboard',
        '/jobs',
        '/jobaplications',
        '/login',
        '/change-password'
      ]

      const isAllowed = allowedPaths.some(path => to.path.startsWith(path))

      if (!isAllowed) {
        return next('/jobs')
      }
    }

    // 3. Validação de Senha Expirada
    if (user.pass_expired === 1) {
      Cookies.remove('ow:user')
      Cookies.remove('ow:userId')
      Cookies.remove('ow:link')
      Cookies.set('ow:userId', user.id)
      const token = await AuthService.passExpired(user.id)
      return next(`/change-password/expired/${token}`)
    }
  }

  // 4. Redirecionamento para Login se não autenticado
  if (authRequired && !loggedIn) {
    Cookies.set('ow:link', to.path)
    return next('/login')
  }

  // 5. Redirecionamento após Login bem sucedido
  if (from.path === '/login' && !userId && loggedIn) {
    const link = Cookies.get('ow:link')
    Cookies.remove('ow:link')
    if (link) {
      return next(`${link}`)
    }
  }

  // Atualiza as rotas no layout lateral antes de prosseguir
  if (router.app?.$root) {
    router.app.$root.$emit('update:routes')
  }

  next()
})

export default router
